import { put, takeEvery, call } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getBaseCommissionRate({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.baseCommissionRate, signal });

    yield put(actions.getBaseCommissionRateDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getBaseCommissionRateFailed,
      endpoint: api.baseCommissionRate
    });
  }
}

export const getBaseCommissionRateSaga = takeEvery(types.GET_BASE_COMMISSION_RATE_REQUEST, getBaseCommissionRate);